export const CustomEvents = {
  START_SHARE_FILE: 'START_SHARE_FILE',
  SHARE_FILE: 'shareFile',
  SHARE_ERROR: 'SHARE_ERROR',
  WATCHER_UPDATED_EVENT: 'WATCHER_UPDATED_EVENT',
  VIDEO_RESIZE_EVENT: 'VideoResizeEvent'
} as const

export type CustomEvent = typeof CustomEvents[keyof typeof CustomEvents]
